import $x from '@/utils/$x';

/**
 * 获取配置列表
 * @param {*} params
 * @returns
 */
export async function getPromptList(params) {
  return $x.post('/prompt/list', params);
}

/**
 * 获取场景列表
 * @param {*} params
 * @returns
 */
export async function getSceneList(params) {
  return $x.post('/prompt/listScene', params);
}

/**
 * 获取场景详情
 * @param {*} params
 * @returns
 */
export async function getPromptDetail(params) {
  return $x.post('/prompt/get', params);
}

/**
 * 修改场景
 * @param {*} params
 * @returns
 */
export async function modifyPrompt(params) {
  return $x.post('/prompt/modify', params);
}

/**
 * 删除场景
 * @param {*} params
 * @returns
 */
export async function delPrompt(params) {
  return $x.post('/prompt/del', params);
}

/**
 * 预览
 * @param {*} params
 * @returns
 */
export async function preview(params) {
  return $x.post('/prompt/preview', params);
}

/**
 * 预览记录
 * @param {*} params
 * @returns
 */
export async function previewLog(params) {
  return $x.post('/prompt/previewLog', params);
}

/**
 * 操作记录
 * @param {*} params
 * @returns
 */
export async function modifyLog(params) {
  return $x.post('/prompt/modifyLog', params);
}
